module.exports = __webpack_public_path__ + "static/media/icon_check.3ec16ad6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_check.svg
// module id = 2056
// module chunks = 0